import React, { useState } from "react";
import menuOptionIcon from "./../../images/menu.svg";
import { MoreOptions } from "./MoreOptions";

interface Props {
  onEdit?: () => unknown | undefined;
  onRemove?: () => unknown | undefined;
}

export const MoreOptionsMenu = ({ onEdit, onRemove }: Props) => {
  const [openOptionModal, setOpenOptionModal] = useState<boolean>(false);

  const iconRef = React.useRef<HTMLDivElement>(null);

  return (
    <div
      ref={iconRef}
      onClick={() => {
        setOpenOptionModal(true);
      }}
      style={{
        position: "relative",
        cursor: "pointer",
      }}
    >
      <img src={menuOptionIcon} alt="menu-option-icon" />

      <MoreOptions
        parentRef={iconRef}
        visible={openOptionModal}
        onClose={() => {
          setOpenOptionModal(false);
        }}
        onEdit={onEdit}
        onRemove={onRemove}
      />
    </div>
  );
};
